<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter>
                    <template #before>
                        <div class="md:flex md:w-full divide-y md:divide-none divide-dashed">
                            <div class="flex md:mb-0 md:w-1/4 md:pr-2 dashed">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5 md:hidden">
                                    戶名
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ before.bankAccountName || '未指定' }}
                                </div>
                            </div>
                            <div class="flex md:mb-0 md:w-2/4 md:pr-2 dashed">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5 md:hidden">
                                    銀行
                                </div>
                                <div class="text-lg text-gray-700">
                                    <div
                                        v-if="before.branchBankNo|| before.headBankNo"
                                        class="md:flex md:flex-wrap"
                                    >
                                        <p class="break-all md:mr-1">
                                            {{ !before.isForeignAccount?before.branchBankNo:before.headBankNo }}
                                        </p>
                                        <p>
                                            {{ !before.isForeignAccount?before.branchBankName:before.headBankName }}
                                        </p>
                                    </div>
                                    <div v-else>
                                        未指定
                                    </div>
                                </div>
                            </div>
                            <div class="flex md:w-1/4 dashed">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5 md:hidden">
                                    帳號
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ before.bankAccount || '未指定' }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #after>
                        <div class="md:flex md:w-full divide-y md:divide-none divide-dashed">
                            <div class="flex md:mb-0 md:w-1/4 md:pr-2 dashed">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5 md:hidden">
                                    戶名
                                </div>
                                <div class="text-lg text-gray-700">
                                    {{ after.bankAccountName }}
                                </div>
                            </div>
                            <div class="flex md:mb-0 md:w-2/4 md:pr-2 dashed">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5 md:hidden">
                                    銀行
                                </div>
                                <div class="text-lg text-gray-700">
                                    <div
                                        v-if="after.branchBankNo|| after.headBankNo"
                                        class="md:flex md:flex-wrap"
                                    >
                                        <p class="break-all md:mr-1">
                                            {{ !after.isForeignAccount?after.branchBankNo:after.headBankNo }}
                                        </p>
                                        <p>
                                            {{ !after.isForeignAccount?after.branchBankName:after.headBankName }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="flex md:w-1/4 dashed">
                                <div class="flex-shrink-0 text-sm leading-7 mr-3.5 md:hidden">
                                    帳號
                                </div>
                                <div class="text-lg text-gray-700 break-all">
                                    {{ after.bankAccount }}
                                </div>
                            </div>
                        </div>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, reactive } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'B5Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const after = reactive(data.value.after);
        const before = reactive(data.value.before);
        const code = ref('B5');
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, before, after, removeService };
    },
};
</script>
<style scoped lang="scss">
.dashed {
    @apply pt-1 first:pt-0 md:pt-0 pb-1 last:pb-0 md:pb-0 md:pr-2.5 last:md:pr-0;
}
</style>
